<template lang="pug">
  vm-prompt(vm-size="medium" @vm-cancel="close" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-buttons-hidden="true" :vm-active="isModalSupplierQuotationsVisible" :vm-title="$t('strings.supplier_quotations')")
    vm-tabs
      vm-tab(vm-label="Agregar cotizaciones")
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group.separator
            vm-select(:placeholder='$t("quotations.supplier_id_placeholder")' warning-text="Este cliente no tiene contactos" v-model="form.supplier_id" :label='$t("quotations.supplier_id")')
              vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in quotationSuppliers")
        vm-col(vm-justify="center", vm-align="center", vm-w=6)
          b-form-group.separator
            h3 Adjunto
            input(type="file" ref="file" v-on:change="handleFileUpload()" accept="application/msword, image/jpeg, image/x-png, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document")
        vm-col(vm-justify="center", vm-align="center", vm-w=12)
          vm-button.float-right(@click="saveAttachment") {{ $t("strings.save") }}
      vm-tab(vm-label="Ver cotizaciones")
        vm-table(max-height="350px" :data="quotation.supplier_quotations")
          template(slot="thead")
            vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('quotations.' + column) }}
          template(slot-scope="{data}")
            vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
              vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                slot(v-if="column == 'total' || column == 'unit_price'")  {{data[indextr][column] | currency }}
                slot(v-if="column != 'attachment' && column != 'supplier_id' && column != 'total' && column != 'unit_price'") {{data[indextr][column]}}
                slot(v-if="column == 'attachment'") {{data[indextr]['attachment']['attachment']}}
                slot(v-if="column == 'supplier_id'") {{data[indextr]['supplier']['name']}}
              vm-td
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="openViewer(data[indextr]['attachment'], indextr)")
                    vm-icon(icon="eye-outline")
                    slot &nbsp;{{ $t('strings.see') }}
                  vm-dropdown-item.d-flex.justify-content-between(@click="download(data[indextr]['attachment'], indextr)")
                    vm-icon(icon="cloud-download-outline")
                    slot &nbsp;{{ $t('strings.download') }}
</template>

<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsSupplier',
  props: {
    form: {
      default: () => [],
      type: Object
    },
    id: {
      default: 1,
      type: Number
    }
  },
  validations: {
    form: {
      supplier: {
        required
      }
    }
  },
  data: () => ({
    description: '',
    step: 1,
    columns: [
      'supplier_id',
      'attachment'
    ]
  }),
  computed: {
    ...mapGetters([
      'isModalSupplierQuotationsVisible',
      'quotationsCatalog',
      'quotationSuppliers',
      'quotation'
    ])
  },
  watch: {
    isModalSupplierQuotationsVisible (flag) {
      if (flag) {
        this.loadQuotation({ id: this.id })
        this.loadQuotationSuppliers(this.id)
      }
    }
  },
  methods: {
    ...mapActions([
      'setModalQuotationsSupplierVisible',
      'addSupplierQuotation',
      'download',
      'loadQuotationSuppliers',
      'loadQuotation',
      'loadQuotations'
    ]),
    async openViewer (attachment) {
      this.setModalQuotationsSupplierVisible(false)
      await this.$viewer.show({
        urlFile: attachment.attachment_doc,
        mime: attachment.mime_type,
        name: attachment.description,
        color: '#FFF'
      })
      this.setModalQuotationsSupplierVisible(true)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    async saveAttachment () {
      await this.addSupplierQuotation({ file: this.file, quotation_id: this.id, form: this.form }).then(() => {
        this.file = null
        this.description = ''
      })
      this.close()
    },
    close () {
      this.setModalQuotationsSupplierVisible(false)
      this.file = null
      this.id = null
      this.description = ''
      this.loadQuotations({ page: 1 })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    }
  }
}
</script>
<style lang="scss">
.vm-stepper {
  padding: 10px !important;
}
.float-right {
  float: right;
}
</style>
